<template lang="pug">
  div
    .visual-title.-xs.-white(:style="`background-image: url(https://cdn.taberutokurasuto.com/image/shop/item/list/freeshipping2.jpg);`")
      .title
        i.h1rem
          LogoYaneSvg
        h1.heading2 {{title}}
        .heading3.curve-bottom Production area
    .archives-description
      p {{selectedRegion.text}}からお届けする食材・グルメ一覧です。全国の生産地域別でお選びいただけます。

    ItemFilterBlock
      DropDown(@change="$_changeOrder" v-model="pageInfo.orderBy" :options="$_orderDropDownOptions")
      //DropDown(@change="$_changeStockFilter" v-model="stockFilter" :options="$_stockDropDownOptions")
      DropDown(@change="changeRegion" v-model="regionCode" :options="regionOptions")
      .stock-checkbok
        FormCheckbox(@change="$_changeStockFilter" v-model="stockOnly") 販売中のみ表示

    ItemCardList
      .item.lg(v-for="(itemGroup, index) in itemGroups" :key="itemGroup.id")
        ItemCard(:itemGroup="itemGroup" eventCategory="商品一覧" pageContents="商品一覧")
    .row
      .col-xs-12(v-if="itemGroups.length === 0")
        .success-notice
          .text-center 商品がありません。
      .col-xs-12
        Pager(@change="$_changePage" :custom-page-info="$_customPageInfo")

    //Row
      template(v-for="region in regionOptions")
        Chip(v-if="region.id === regionCode" color="primary") {{region.text}}
        Chip(v-else @click="changeRegion(region.id)") {{region.text}}

    SectionItemArchive
</template>

<script>
import { GetItemGroupsForApi } from "../../graphqls/ItemGroups";

  import LogoYaneSvg from "../../components/svg/LogoYaneSvg";
  import ItemList from "../../components/list/ItemList";
  import GlobalMixin from "../../mixin/GlobalMixin";
  import Pager from "../../components/paginate/Pager";
  import DropDown from "../../components/dropdown/DropDown";
  import ItemListMixin from "../../mixin/ItemListMixin";
  import Chip from "../../components/badge/Chip";
  import Row from "../../components/layout/Row";
  import Col from "../../components/layout/Col";
  import SectionItemArchive from "../../components/v1/section/SectionItemArchive";
  import ItemFilterBlock from "../../components/v1/item/ItemFilterBlock";
  import FormCheckbox from "../../components/v1/form/FormCheckbox";
  import ItemCardList from "../../components/v1/item/ItemCardList";
  import ItemCard from "../../components/v1/item/ItemCardForApi";

  export default {
    name: "production-area-items-index",
    mixins: [GlobalMixin, ItemListMixin],
    components: {
      ItemCard,
      ItemCardList,
      FormCheckbox,
      ItemFilterBlock,
      SectionItemArchive,
      Col,
      Row,
      Chip,
      DropDown,
      Pager,
      ItemList,
      LogoYaneSvg
    },
    props: [],
    data() {
      return {
        itemGroups: [],
        pageInfo: {
          currentPage:  Number(this.$route.params.page || 1),
          totalCount: 0,
          perPage: 48,
          orderBy: this.$route.query.order || 'popular'
        },
        stockOnly: this.$route.query?.stock === 'instock',
        withinYearItem: this.$route.query.wiy === 'true',
        regionCode: this.$route.params.region || ''
      }
    },
    computed: {
      regionOptions() {
        let result = []
        result.push({id: '01', text: '北海道'})
        result.push({id: '02', text: '北東北'})
        result.push({id: '03', text: '南東北'})
        result.push({id: '04', text: '関東'})
        result.push({id: '05', text: '信越'})
        result.push({id: '06', text: '東海'})
        result.push({id: '07', text: '北陸'})
        result.push({id: '08', text: '関西'})
        result.push({id: '09', text: '中国'})
        result.push({id: '10', text: '四国'})
        result.push({id: '11', text: '九州'})
        result.push({id: '12', text: '沖縄'})
        return result
      },
      selectedRegion() {
        return this.regionOptions.find(r => r.id === this.regionCode)
      },
      title() {
        if (this.selectedRegion && this.regionCode) {
          return `${this.selectedRegion.text}産の商品`
        }
        return '産地別商品'
      },
      topRouterName() {
        return 'production-area-items-index'
      },
      pageRouterName() {
        return 'production-area-items-page-index'
      },
      stockFilter() {
        return this.stockOnly ? 'instock' : 'outstock'
      }
    },
    mounted() {
      this.fetchItemGroups()
    },
    methods: {
      async fetchItemGroups() {
        this.loadingStart();
        const { data } = await this.$apollo
        .query({
          query: GetItemGroupsForApi,
          variables: {
            productionRegion: this.regionCode,
            stockFilter: this.stockFilter,
            withinYearItem: this.withinYearItem,
            ...this.pageInfo
          },
          client: 'apiClient'
        })
        .catch(error => {
          this.loadingStop()
          return;
        });
        this.itemGroups = data.itemGroups.items;
        this.pageInfo = data.itemGroups.pageInfo
        this.loadingStop();
        this.$_gaSendViewItemList(this.itemGroups, 'shops/items/productionarea', this.pageInfo)
      },
      updateItemGroup(newItemGroup) {
        if (this.itemGroups[0].id === newItemGroup.id) {
          this.firstItemGroup = newItemGroup
        }
      },
      changeRegion(region) {
        this.regionCode = region
        this.$router.push({name: 'production-area-items-index', params: {region: this.regionCode}})
        this.fetchItemGroups()
      }
    },
    watch: {
      regionCode: function (newQuestion, oldQuestion) {
        this.stockOnly = false
        this.pageInfo.orderBy = 'popular'
        this.pageInfo.currentPage = 1
        this.fetchItemGroups()
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
